import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEnd } from "services/schedule/kindergartenScheduleSlice";
import { setStart } from "services/schedule/kindergartenScheduleSlice";
const SelectTime = () => {
  const dispatch = useDispatch();
  const [startTimeLimit, setStartTimeLimit] = useState("06:00");
  const [endTimeLimit, setEndTimeLimit] = useState("00:00");
  const kindergartenSchedule = useSelector((state) => {
    return state.kindergartenSchedule;
  });

  useEffect(() => {
    if (kindergartenSchedule.schedule.shift != null) {
      setStartTimeLimit(
        kindergartenSchedule.schedule.shift.start.substring(0, 5)
      );
      setEndTimeLimit(kindergartenSchedule.schedule.shift.end.substring(0, 5));
      setStart(kindergartenSchedule.schedule.shift.start.substring(0, 5));
    }
  }, [kindergartenSchedule.schedule.shift]);

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label
          htmlFor="start_time_label"
          className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
        >
          Эхлэх цаг
        </label>
        <input
          value={kindergartenSchedule.data.start}
          min={startTimeLimit}
          max={endTimeLimit}
          className="flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
          onChange={(e) => {
            dispatch(setStart(e.target.value));
          }}
          type="time"
        />
      </div>
      <div>
        <label
          htmlFor="end_time_label"
          className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
        >
          Дуусах цаг
        </label>
        <input
          value={kindergartenSchedule.data.end}
          min={kindergartenSchedule.data.start}
          max={endTimeLimit}
          onChange={(e) => {
            dispatch(setEnd(e.target.value));
          }}
          className="flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
          type="time"
        />
      </div>
    </div>
  );
};

export default SelectTime;
